module.exports = __webpack_public_path__ + "static/media/amcat.4c7b41cd.jpg";